import React from "react"
import PropTypes from "prop-types"
import { useClearRefinements } from "react-instantsearch"

function Clear(){
	  const { refine, canRefine } = useClearRefinements();
    return ( <button className="search__clear" onClick={() => refine()}>
        		clear
        		<svg><use xlinkHref="#cross-sign-square-icon" /></svg>
   		 	 </button>)
}
Clear.propTypes = {
	refine: PropTypes.func.isRequired,
}
export default Clear